export const sanitizePhoneInput = (value: string): string => {
  if (!value) {
    return '';
  }
  const cleaned: string = value.replace(/[^0-9+()\-\s]/g, '');

  let result: string = '';
  let plusSeen: boolean = false;

  for (let i = 0; i < cleaned.length; i += 1) {
    const char: string = cleaned[i] as string;

    if (char === '+') {
      if (plusSeen || i !== 0) {
        continue;
      }
      plusSeen = true;
    }

    result += char;
  }

  return result;
};
